/**
 *  A helper function to see if a specific input is an enum value.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isEnum<TEnum extends object>(input: any, suspect: TEnum): input is TEnum[keyof TEnum] {
  return Object.values(suspect).includes(input)
}
